import { Tabs, Tab } from '@heroui/react'
import { usePostHog } from '@posthog/react'
import { useAppSelector } from '@/redux/hooks'
import { useTranslate } from '@/hooks'
import { BankIcon } from '@/ui/icons/bank'
import { GlobeIcon } from '@/ui/icons/globe'
import { IbanForm, IbanFormData } from './iban-form'
import { InternationalForm, InternationalFormData } from './international-form'

interface BankTransferProps {
  onSubmit: (data: IbanFormData | InternationalFormData) => void
}

export const BankTransfer = ({ onSubmit }: BankTransferProps) => {
  const { translate } = useTranslate()

  const order = useAppSelector((store) => store.returnsApi.order.response)

  const posthog = usePostHog()

  return (
    <div className="space-y-3">
      <div>
        <h2
          className="text-base font-medium"
          dangerouslySetInnerHTML={{
            __html: translate('confirmation_page_bank_transfer_title')
          }}
        />
        <h3
          className="text-[0.8125rem] font-normal leading-normal text-neutral-500"
          dangerouslySetInnerHTML={{
            __html: translate('confirmation_page_bank_transfer_subtitle')
          }}
        />
      </div>
      <Tabs
        aria-label="Options"
        size="md"
        radius="sm"
        classNames={{
          base: 'pl-0.5',
          tabList: 'rounded-md',
          tab: 'data-selected:font-semibold w-32 truncate',
          cursor: '!bg-white',
          panel: '!mt-2'
        }}
        onSelectionChange={(key) => {
          posthog.capture('Bank Transfer Tab Selected', {
            tab: key,
            checkout_id: order.checkout_id
          })
        }}
      >
        <Tab
          key="iban"
          title={
            <div className="flex items-center gap-2">
              <BankIcon className="size-4" />
              {translate('confirmation_page_bank_transfer_iban_title')}
            </div>
          }
        >
          <IbanForm onSubmit={onSubmit} />
        </Tab>
        <Tab
          key="international"
          title={
            <div className="flex items-center gap-2">
              <GlobeIcon className="size-4" />
              {translate('confirmation_page_bank_transfer_international_title')}
            </div>
          }
        >
          <InternationalForm onSubmit={onSubmit} />
        </Tab>
      </Tabs>
    </div>
  )
}
